
import { mapGetters } from "vuex"
import user from "@/mixins/user"

export default {
  mixins: [user],

  data() {
    return {
      showPrices: {
        your: this.$auth.user?.isYourPrice,
        msrp: this.$auth.user?.isMsrpPrice
      },

      showProducts: false,

      welcomeVisible: false,
      welcomeTimer: null
    }
  },

  computed: {
    ...mapGetters({
      cartLength: "CART/CART_LENGTH",
      cartLoaded: "CART/CART_LOADED",
      wishlistLoaded: "WISHLIST/WISHLIST_LOADED",
      wishlistLength: "WISHLIST/WISHLIST_LENGTH",
      config: "CONFIG/CONFIG"
    })
  },

  watch: {
    "showPrices.your"(show) {
      this.changePrice("user/price-your", show)
    },

    "showPrices.msrp"(show) {
      this.changePrice("user/price-msrp", show)
    },

    // Fires when the header is already mounted and a login flips the flag.
    // The login page's own header (auth layout) must NOT consume the one-shot
    // flag — it gets destroyed on the post-login redirect. Let the destination
    // header pick it up in mounted() instead.
    "config.showWelcome"(show) {
      if (show && this.$route.name !== "login") this.maybeShowWelcome()
    }
  },

  methods: {
    toggleSearch() {
      this.$store.commit("CONFIG/SET_IS_SEARCH_ACTIVE", !this.config.isSearchActive)

      this.$store.commit("CONFIG/SET_IS_BACK_ACTIVE", this.config.isSearchActive)
    },

    toggleSidebar() {
      this.$store.commit("CONFIG/SET_IS_SIDEBAR_ACTIVE", !this.config.isSidebarActive)

      this.$store.commit("CONFIG/SET_IS_BACK_ACTIVE", this.config.isSidebarActive)
    },

    toggleUserOverlay(e) {
      this.$refs["user-overlay"].toggle(e)
    },

    async updateCart() {
      try {
        await this.$store.dispatch("CART/GET", {
          sp: 0
        })
      } catch (err) {
        this.__logError(err)
      }
    },

    async updateWishlist() {
      try {
        await this.$store.dispatch("WISHLIST/GET")
      } catch (err) {
        this.__logError(err)
      }
    },

    async changePrice(action, show) {
      try {
        await this.$axios.$post(action, {
          show
        })
        await this.$auth.fetchUser()
      } catch (err) {
        this.__toastError(err)
      }
    },

    // Consume the one-shot login flag (set in pages/login.vue) and show the
    // welcome toast for 5s. Resets the flag immediately so it fires once.
    maybeShowWelcome() {
      if (!this.config.showWelcome) return

      this.$store.commit("CONFIG/SET_SHOW_WELCOME", false)
      this.welcomeVisible = true

      clearTimeout(this.welcomeTimer)
      this.welcomeTimer = setTimeout(() => {
        this.welcomeVisible = false
      }, 5000)
    },

    closeWelcome() {
      clearTimeout(this.welcomeTimer)
      this.welcomeVisible = false
    }
  },

  mounted() {
    this.updateCart()
    // Header mounts fresh after the post-login redirect, so check the flag here.
    this.maybeShowWelcome()
  },

  beforeDestroy() {
    clearTimeout(this.welcomeTimer)
  }
}
